import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';

import messages from '../../locale/messages';

import FaceBookIcon from '../../../public/Icons/fb.png';
import InstaIcon from '../../../public/Icons/insta.png';
import TwitterIcon from '../../../public/Icons/twitter.png';
import YouTubeIcon from '../../../public/Icons/youtube.png';

import s from './Footer.css';

class SocialMediaSupport extends React.Component {
    render() {
        const { youtubeLink, twitterLink, facebookLink, instagramLink } = this.props;
        const { formatMessage } = this.props.intl

        return (
            <div className={cx(s.content)}>
                <h3 className={cx('textAlignRightRTL', 'textWhite')}>{formatMessage(messages.followUs)}</h3>
                <ul className='textAlignRightRTL'>
                    <li className={cx(s.displayInlineBlock, s.iconPaddingRight, 'iconNoPaddingRTL')}>
                        <a href={facebookLink} target="_blank" >
                            <img src={FaceBookIcon} className={s.socialIcon} />
                        </a>
                    </li>
                    <li className={cx(s.displayInlineBlock, s.iconPaddingRight)}>
                        <a href={instagramLink} target="_blank" >
                            <img src={InstaIcon} className={s.socialIcon} />
                        </a>
                    </li>
                    <li className={cx(s.displayInlineBlock, s.iconPaddingRight, 'iconNoPaddingTabRTL')}>
                        <a href={twitterLink} target="_blank" >
                            <img src={TwitterIcon} className={s.socialIcon} />
                        </a>
                    </li>
                    <li className={cx(s.displayInlineBlock, 'iconPaddingRightRTL')}>
                        <a href={youtubeLink} target="_blank" >
                            <img src={YouTubeIcon} className={s.socialIcon} />
                        </a>
                    </li>
                </ul>
            </div>
        )
    }
}

const mapState = (state) => ({
    youtubeLink: state?.siteSettings?.data?.youtubeLink,
    twitterLink: state?.siteSettings?.data?.twitterLink,
    facebookLink: state?.siteSettings?.data?.facebookLink,
    instagramLink: state?.siteSettings?.data?.instagramLink
})

const mapDispatch = {
}

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(SocialMediaSupport)));